const request = require('superagent');
import networkLogger from './networkLogger';
import { graphQLRequestIAM } from './graphQLService';

const ERSSurl = process.env.ERSS_ENDPOINT;

const GET_NEXT = `
  query getNextErssActivity(
    $studentId: String!, $isEarlyReader: Boolean, $isSpanishEarlyReader: Boolean){
      getNextErssActivity(studentId:$studentId, isEarlyReader: $isEarlyReader, isSpanishEarlyReader: $isSpanishEarlyReader){
        nextStories {
          locale
          storyId
        }
        error
    }
  }`;

const GET_STATUS = `
  query status(
    $studentId: String!){
    getErssStatus(studentId: $studentId) {
      domain
      progression{
        skillId
        subSkills {
          skillId
          taken
          current
        }
      }
    }
  }
`
const UPDATE_STATUS = `
  mutation updateStatus(
    $studentId: String!,
    $activityId: String!,
    $tags: [String]
    $status: Status
    $storyId: String){
      updateErssStatus(studentId: $studentId,activityId: $activityId,tags: $tags, status: $status, storyId: $storyId){
        activityId
        studentId
        skills
        nextSeq
        error
      }
    }
`
export async function getNextErssActivity(studentId,isEarlyReader,isSpanishEarlyReader){
  const data = await graphqlRequest(GET_NEXT, {studentId,isEarlyReader,isSpanishEarlyReader});
  return data.getNextErssActivity;
}

export async function getErssStatus(studentId){
  const data = await graphqlRequest(GET_STATUS, {studentId});
  return data.getErssStatus;
}

/**
 * Updates the ERSS status for a given activity.
 * Validates that required fields are present before sending the GraphQL request
 * to avoid 'coerced Null value for NonNull type' errors from the server.
 *
 * storyId is required for Spanish. Spanish stories carry no ERSS-SEQ_ tag, so ERSS places a
 * Spanish completion in the sequence by story id alone. Without it ERSS rejects the write with
 * 'not an ERSS sequence story' and the student never advances past the first story (TT-1421).
 * English stories carry the tag, so storyId is optional there and ERSS ignores it.
 */
export async function updateErssStatus(studentId,activityId,tags,status,storyId){
  if (!studentId || !activityId) {
    console.warn('updateErssStatus called with missing required fields:', {studentId, activityId, status});
    return null;
  }
  const data = await graphqlRequest(UPDATE_STATUS, {studentId,activityId,tags,status,storyId});
  const result = data.updateErssStatus;
  // ERSS returns { error } rather than throwing when it cannot place the activity.
  if (result && result.error) {
    console.warn('updateErssStatus not recorded by ERSS:', {studentId, activityId, status, storyId, error: result.error});
  }
  return result;
}

async function graphqlRequest(query, variables) {
  const startTime = Date.now();
  try {
    const response = await graphQLRequestIAM(ERSSurl, query, variables, 3);
    const duration = Date.now() - startTime;

    if (response.errors) {
      console.log(response.errors);
      networkLogger.logGraphQLError(
        'ErssService',
        ERSSurl,
        null,
        response.errors,
        duration
      );
      const graphqlError = new Error(response.errors[0].message);
      graphqlError.isGraphQLError = true;
      throw graphqlError;
    }

    return response.data;
  } catch (error) {
    if (!error.isGraphQLError) {
      networkLogger.logGraphQLError(
        'ErssService',
        ERSSurl,
        null,
        error,
        Date.now() - startTime
      );
    }
    throw error;
  }
}
